import type { GridColumnProps } from "@tql/ui-components-react/kendo/grid";
import { memo } from "react";

import { TraxGrid } from "~/shared/components/trax-grid/trax-grid.tsx";
import { useIsMobile } from "~/shared/hooks/use-is-mobile.ts";
import type { Invoice } from "~/shared/schemas/invoice-schema";
import { formatCurrency } from "~/shared/utils/string-fns.ts";

import { SelectedInvoicesPaymentMobile } from "./mobile/selected-invoices-payment-mobile/selected-invoices-payment-mobile.tsx";

type SelectedInvoicesPaymentProps = {
	invoices: Invoice[];
	columns: GridColumnProps[];
	totalPayment: number;
	onAmountChange: (invoiceId: string, amount: number) => void;
	onDeleteInvoice: (invoiceId: string) => void;
};

export const SelectedInvoicesPayment = memo<SelectedInvoicesPaymentProps>(
	({
		invoices,
		columns,
		totalPayment,
		onAmountChange,
		onDeleteInvoice,
	}: SelectedInvoicesPaymentProps) => {
		const isMobile = useIsMobile();

		if (isMobile) {
			return (
				<SelectedInvoicesPaymentMobile
					invoices={invoices}
					onAmountChange={onAmountChange}
					onDeleteInvoice={onDeleteInvoice}
					totalPayment={totalPayment}
				/>
			);
		}

		return (
			<div>
				<TraxGrid
					className={"payment-grid"}
					columns={columns}
					data={invoices}
					editable={false}
				/>
				<div
					style={{
						marginTop: "1rem",
						display: "flex",
						flexDirection: "column",
						alignItems: "flex-end",
					}}
				>
					<h4>Total Payment (USD)</h4>
					<h4>{formatCurrency(totalPayment)}</h4>
				</div>
			</div>
		);
	},
);

SelectedInvoicesPayment.displayName = "SelectedInvoicesPayment";
